module.exports = __webpack_public_path__ + "static/character-1-88b9ba25c32fd3f85a9e7ebaa691dc2e.png";